define('all/player/password',['jquery'], function($) {
	'use strict';

	var STRENGTH = {
		NONE: {score: 0, strength: 'NONE'},
		WEAK: {score: 1, strength: 'WEAK'},
		FAIR: {score: 60, strength: 'FAIR'},
		STRONG: {score: 80, strength: 'STRONG'}
	};

	var comment = 'Possible scores: NONE, WEAK, FAIR, STRONG';

	function scorePassword(password) {

		// handles undefined, null etc -> ''
		password = $.trim(password);

		if (password.length === 0) {
			return scoreToStrength(0);
		}

		var score = 0;

		// award each letter for its "uniqueness" with diminishing returns,
		// while still adding score for the password being longer
		// - abcdef scores a bit better than aaaaaa
		var letters = {};
		$.each(password.split(''), function(index, letter) {
			letters[letter] = (letters[letter] || 0) + 1;
			score += 5.0 / letters[letter];
		});

		// better score for:
		// digits not at the end
		// lowercase anywhere
		// uppercase not as first letter
		// special symbol not as last letter
		var variations = {
			digits: /\d(?:\D|$)/.test(password),
			lower: /[a-z]/.test(password),
			upper: /.[A-Z]/.test(password),
			symbol: /\W(.|$)/.test(password)
		};

		var variationCount = 0;
		for (var check in variations) {
			if (variations.hasOwnProperty(check)) {
				variationCount += (variations[check]) ? 1 : 0;
			}
		}

		score += (variationCount - 1) * 10;

		return scoreToStrength(score);
	}

	function scoreToStrength(score) {
		var strength = $.extend({}, STRENGTH.NONE);

		$.each(STRENGTH, function(name, cmpStrength) {
			if (score >= cmpStrength.score && cmpStrength.score > strength.score) {
				strength = $.extend(strength, cmpStrength);
			}
		});

		strength.score = score;
		strength.comment = comment;
		return strength;
	}

	window.password = {
		updatePasswordStrength: function(el) {
			var $el = $(el);
			var password = $.trim($el.val());
			var $parent = $el.parentsUntil('form');

			var result = scorePassword(password);
			$parent.find('#password-strength-w, #password-strength-m, #password-strength-s').removeClass('selected');

			if (result.strength === STRENGTH.WEAK.strength) {
				$parent.find('#password-strength-w').addClass('selected');
			}
			if (result.strength === STRENGTH.FAIR.strength) {
				$parent.find('#password-strength-w').addClass('selected');
				$parent.find('#password-strength-m').addClass('selected');
			}
			if (result.strength === STRENGTH.STRONG.strength) {
				$parent.find('#password-strength-w').addClass('selected');
				$parent.find('#password-strength-m').addClass('selected');
				$parent.find('#password-strength-s').addClass('selected');
			}
		},
		updatePasswordStrengthModal: function(el) {
			var $el = $(el);
			var password = $.trim($el.val());
			var $parent = $el.parentsUntil('password-strength-dl');

			var result = scorePassword(password);
			$parent.find('#password-strength-w, #password-strength-m, #password-strength-s').removeClass('selected');

			if (result.strength === STRENGTH.WEAK.strength) {
				$parent.find('#password-strength-w').addClass('selected');
			}
			if (result.strength === STRENGTH.FAIR.strength) {
				$parent.find('#password-strength-w').addClass('selected');
				$parent.find('#password-strength-m').addClass('selected');
			}
			if (result.strength === STRENGTH.STRONG.strength) {
				$parent.find('#password-strength-w').addClass('selected');
				$parent.find('#password-strength-m').addClass('selected');
				$parent.find('#password-strength-s').addClass('selected');
			}
		}
	};

});

